import { Navigate, useParams } from "react-router-dom";

const ImportDetails = () => {
	const { runId } = useParams();

	if (!runId) {
		return <Navigate replace to="/validate" />;
	}

	return <Navigate replace to={`/validate?importRun=${encodeURIComponent(runId)}`} />;
};

export default ImportDetails;
